module.exports = {
  CUSTOMER: 'customer',
  SHIPPING_METHOD: 'shippingMethod', // Optional stage, not shown for online shipping method
  SHIPPING_ADDRESS: 'shippingAddress', // Optional stage, not shown for online shipping method
  SHIPPING_SUMMARY: 'shippingSummary', // Optional stage, not shown for online shipping method
  PAYMENT_METHOD: 'paymentMethod',
  PAYMENT_DETAILS: 'payment', // Optional stage, only shown if needed
  SECOND_PAYMENT_METHOD: 'secondPaymentMethod', // Optional stage, only shown if needed for GIFT_CARD
  SECOND_PAYMENT_DETAILS: 'secondPayment', // Optional stage, only shown if needed for GIFT_CARD
  BILLING_ADDRESS: 'billing', // Optional stage, only shown if needed
  PLACE_ORDER: 'placeOrder',
  SUBMITTED: 'submitted',
};
